var React = require('react');

function LightCeiling (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M224.24,162.07V0h64.07V162.05a258.93,258.93,0,0,0-32-2.22A257.16,257.16,0,0,0,224.24,162.07Zm32,349.93a64,64,0,0,0,64.07-64H192.21A64,64,0,0,0,256.27,512Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256.28,159.83c-127.93,0-238,94.42-255.95,219.62A32,32,0,0,0,32,416h0L480,415.83a32,32,0,0,0,31.72-36.39C494.32,254.24,384.52,159.83,256.28,159.83Z","className":"fa-primary","key":2})]);
}

LightCeiling.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = LightCeiling;

LightCeiling.default = LightCeiling;
